import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Lightweight leave-page warning for the assets page (DV-2750). Shown when
 * the user navigates away with session-local unsynced edits. Deliberately
 * NOT DiscardChangesDialog: edits are already persisted — leaving loses
 * nothing, the photos just haven't been synced yet. Persisted backend
 * unsynced flags do not trigger this (they'd nag on every visit).
 */
export function UnsyncedLeaveDialog({ open, onStay, onLeave }: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) onStay();
      }}
      title="Unsynced Changes"
      description="Your changes are saved, but they haven't been synced yet."
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onStay} autoFocus>
            Stay
          </Button>
          <Button onClick={onLeave}>Leave Anyway</Button>
        </>
      }
    />
  );
}
